const exportNs = {
  exportCsv: "ייצוא CSV",
  exporting: "מייצא...",
  exportSuccess: "הקובץ יורד בהצלחה",
  exportError: "שגיאה בייצוא",
  exportEmpty: "אין נתונים לייצוא",
  noData: "אין נתונים לייצוא",
} as const;
export default exportNs;
